import React, { useReducer } from 'react'
import Card from '../lib/card'
import TextArea from '../lib/textarea'
import { PrimaryButton } from '../lib/button/button.styled'
import Error from '../lib/error'
import { useTranslation } from 'react-i18next'
import useSubmitEvaluation from '../../hooks/useSubmitEvaluation'
import SelectNextCheck from '../select-next-check'
import { initialState, reducer } from '../../reducers/addRecordReducer'
import Checkbox from '../lib/Checkbox'
import StyledRunningRecord from './StyledRunningRecord.styled'
import SelectProgramType from '../SelectProgramType'
import { add, formatISO } from 'date-fns'

interface IAddRecordProps {
  programStep: number | undefined
  totalStepCount: number | undefined
  createdAt: string | Date
}

const AddRunningRecord: React.FC<IAddRecordProps> = ({
  programStep,
  totalStepCount,
  createdAt,
}) => {
  const { t } = useTranslation()
  const evaluation = useSubmitEvaluation()
  const [{ isError, nextCheck, recordText, programType, selectedCheckboxes }, dispatch] =
    useReducer(reducer, initialState)

  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault()

    const textToSubmit = recordText.trim()

    if (!textToSubmit || !nextCheck || !programType) {
      dispatch({ type: 'ADD_RECORD_SET_ERROR' })
      return
    }

    let nextCheckFormatted: string = nextCheck
    switch (nextCheck) {
      case '1w':
        nextCheckFormatted = formatISO(add(new Date(), { weeks: 1 }))
        break
      case '2w':
        nextCheckFormatted = formatISO(add(new Date(), { weeks: 2 }))
        break
      case '1m':
        nextCheckFormatted = formatISO(add(new Date(), { months: 1 }))
        break
      case '2m':
        nextCheckFormatted = formatISO(add(new Date(), { months: 2 }))
        break
      case '3m':
        nextCheckFormatted = formatISO(add(new Date(), { months: 3 }))
        break
      case '6m':
        nextCheckFormatted = formatISO(add(new Date(), { months: 6 }))
        break
      default:
        nextCheckFormatted = formatISO(new Date())
    }

    evaluation.mutate({
      description: recordText,
      riskCategoryId: programType,
      nextCheckAt: nextCheckFormatted,
      data: {
        ...selectedCheckboxes,
      },
    })

    dispatch({ type: 'ADD_RECORD_SUCCESS' })
  }

  return (
    <Card date={createdAt}>
      <StyledRunningRecord>
        <div>
          <label htmlFor='add-record' className='add-note'>
            {t('addRecord.addRecord')}
          </label>
        </div>
        <TextArea
          placeholder={t('general.startWriting')}
          labelId='add-record'
          onChangeHandler={(e) => dispatch({ type: 'ADD_RECORD_INPUT_CHANGE', payload: e })}
          value={recordText}
        />

        <div className='checkbox-wrapper'>
          <Checkbox
            style={{ marginBottom: 16 }}
            checked={selectedCheckboxes.diabetes}
            label={t('addRunningCycleRecord.checkboxes.diabetes')}
            onChangeHandler={(ch) =>
              dispatch({
                type: 'ADD_SELECTED_CHECKBOXES_CHANGE',
                payload: { ...selectedCheckboxes, diabetes: ch },
              })
            }
          />

          <Checkbox
            style={{ marginBottom: 16 }}
            checked={selectedCheckboxes.obesity}
            label={t('addRunningCycleRecord.checkboxes.obesity')}
            onChangeHandler={(ch) =>
              dispatch({
                type: 'ADD_SELECTED_CHECKBOXES_CHANGE',
                payload: { ...selectedCheckboxes, obesity: ch },
              })
            }
          />
          <Checkbox
            style={{ marginBottom: 16 }}
            checked={selectedCheckboxes.smoker}
            label={t('addRunningCycleRecord.checkboxes.smoker')}
            onChangeHandler={(ch) =>
              dispatch({
                type: 'ADD_SELECTED_CHECKBOXES_CHANGE',
                payload: { ...selectedCheckboxes, smoker: ch },
              })
            }
          />
          {/*         <Checkbox style={{ marginBottom: 16 }} checked={false} label={t('addRunningCycleRecord.checkboxes.info4')} />
          <Checkbox style={{ marginBottom: 16 }} checked={false} label={t('addRunningCycleRecord.checkboxes.info5')} />
          <Checkbox style={{ marginBottom: 16 }} checked={false} label={t('addRunningCycleRecord.checkboxes.info6')} />
          <Checkbox style={{ marginBottom: 16 }} checked={false} label={t('addRunningCycleRecord.checkboxes.info7')} />
          <Checkbox style={{ marginBottom: 16 }} checked={false} label={t('addRunningCycleRecord.checkboxes.info8')} /> */}
        </div>

        <SelectNextCheck dispatch={dispatch} dropdownValue={nextCheck} />
        <SelectProgramType dispatch={dispatch} dropdownValue={programType} />

        <p>
          {t('addRunningCycleRecord.feed.step')}:{' '}
          <span>
            {programStep} / {totalStepCount}
          </span>
        </p>

        {isError && <Error>{t('addRecord.fillAll')}</Error>}
        <div className='buttons'>
          <PrimaryButton type='button' onClick={handleButtonClick}>
            {t('general.save')}
          </PrimaryButton>
        </div>
      </StyledRunningRecord>
    </Card>
  )
}

export default AddRunningRecord
